import http from "../../http-common";

const getAllEntries = async (query) => {
  return await http.get("/ultimate/cash/entries", { params: query })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getSummary = async (query) => {
  return await http.get("/ultimate/cash/summary", { params: query })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getDescriptions = async (query) => {
  return await http.get("/ultimate/cash/descriptions", { params: query })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const createEntry = async (data) => {
  return await http.post("/ultimate/cash/entries", data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const updateEntry = async (id, data) => {
  return await http.put(`/ultimate/cash/entries/${id}`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const settleEntry = async (id, data) => {
  return await http.put(`/ultimate/cash/entries/${id}/settle`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const cancelEntry = async (id) => {
  return await http.put(`/ultimate/cash/entries/${id}/cancel`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getDre = async (query) => {
  return await http.get("/ultimate/cash/dre", { params: query })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getCategories = async (query) => {
  return await http.get("/ultimate/cash/categories", { params: query })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const createCategory = async (data) => {
  return await http.post("/ultimate/cash/categories", data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const updateCategory = async (id, data) => {
  return await http.put(`/ultimate/cash/categories/${id}`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const deleteCategory = async (id) => {
  return await http.delete(`/ultimate/cash/categories/${id}`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const backfillInvoices = async () => {
  return await http.post("/ultimate/cash/backfill")
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  getAll: getAllEntries,
  getSummary,
  getDescriptions,
  getDre,
  getCategories,
  createCategory,
  updateCategory,
  deleteCategory,
  create: createEntry,
  update: updateEntry,
  settle: settleEntry,
  cancel: cancelEntry,
  backfill: backfillInvoices,
};
